import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_GET_OGM_SUBS_DATA_BEGIN,
  MANAGE_SUBS_GET_OGM_SUBS_DATA_SUCCESS,
  MANAGE_SUBS_GET_OGM_SUBS_DATA_FAILURE,
  MANAGE_SUBS_GET_OGM_SUBS_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

// Thunk action for fetching OGM substitutions data (does NOT update table data)
export function getOgmSubstitutionsData(args = {}) {
  return (dispatch, getState) => {
    dispatch({
      type: MANAGE_SUBS_GET_OGM_SUBS_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      const doRequest = axios.post(`${API_REQUEST_URL}/getOrderGuideSubsData`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_GET_OGM_SUBS_DATA_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_GET_OGM_SUBS_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetOgmSubstitutionsDataError() {
  return {
    type: MANAGE_SUBS_GET_OGM_SUBS_DATA_DISMISS_ERROR,
  };
}

export function useGetOgmSubstitutionsData() {
  const dispatch = useDispatch();

  const { getOgmSubstitutionsDataPending, getOgmSubstitutionsDataError } = useSelector(
    state => ({
      getOgmSubstitutionsDataPending: state.manageSubs.getOgmSubstitutionsDataPending,
      getOgmSubstitutionsDataError: state.manageSubs.getOgmSubstitutionsDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(getOgmSubstitutionsData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetOgmSubstitutionsDataError());
  }, [dispatch]);

  return {
    getOgmSubstitutionsData: boundAction,
    getOgmSubstitutionsDataPending,
    getOgmSubstitutionsDataError,
    dismissGetOgmSubstitutionsDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_GET_OGM_SUBS_DATA_BEGIN:
      return {
        ...state,
        getOgmSubstitutionsDataPending: true,
        getOgmSubstitutionsDataError: null,
      };

    case MANAGE_SUBS_GET_OGM_SUBS_DATA_SUCCESS:
      return {
        ...state,
        getOgmSubstitutionsDataPending: false,
        getOgmSubstitutionsDataError: null,
      };

    case MANAGE_SUBS_GET_OGM_SUBS_DATA_FAILURE:
      return {
        ...state,
        getOgmSubstitutionsDataPending: false,
        getOgmSubstitutionsDataError: action.data.error,
      };

    case MANAGE_SUBS_GET_OGM_SUBS_DATA_DISMISS_ERROR:
      return {
        ...state,
        getOgmSubstitutionsDataError: null,
      };

    default:
      return state;
  }
}